import type { TOC } from '@ember/component/template-only';

interface EmptyStateSignature {
  Args: {
    /** The message shown to the user, e.g. "You have no upcoming sessions." */
    message: string;
    /** Optional Phosphor (`ph:`) icon shown before the message. */
    icon?: string;
  };
  Blocks: {
    /** Optional call-to-action (e.g. a button/link) shown below the message. */
    action: [];
  };
  Element: HTMLDivElement;
}

export const EmptyState = <template>
  {{! `alert-primary` read as a colour-tinted warning rather than a neutral
      "nothing to report" state — design calls for a plain surface with the
      icon alone carrying the accent colour. `bg-body` is the page surface,
      which the theme keeps one step darker than a card in both colour modes,
      so this reads as a well cut into the card it sits in. }}
  <div class="bg-body rounded-3 p-3" ...attributes>
    <div class="d-flex align-items-center gap-2">
      {{#if @icon}}
        <iconify-icon
          icon={{@icon}}
          inline
          aria-hidden="true"
          class="text-primary flex-shrink-0"
        />
      {{/if}}
      <p class="mb-0 text-body-emphasis">{{@message}}</p>
    </div>
    {{#if (has-block "action")}}
      <div class="mt-3">
        {{yield to="action"}}
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<EmptyStateSignature>;
